import React, { useState } from "react";
import { Plus } from "lucide-react";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Fld, inputCls } from "./shared";

export function AddAccountDialog({ onAdded }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [type, setType] = useState("bank");
  const save = async () => {
    try {
      const { data } = await api.post("/finance/cash/accounts", { name, type });
      toast.success(`${data.name} added`); setOpen(false); setName(""); onAdded(data);
    } catch (e) { toast.error(formatError(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button data-testid="button-add-cash-account" variant="outline" className="border-slate-700 bg-slate-900 hover:bg-slate-800"><Plus size={14} className="mr-1" /> Add account</Button>
      </DialogTrigger>
      <DialogContent className="bg-slate-900 border-slate-700 text-slate-100">
        <DialogHeader><DialogTitle>Add cash or bank account</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <Fld label="Name">
            <Input data-testid="input-cash-account-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. BDO Current" className={inputCls} />
          </Fld>
          <Fld label="Type">
            <Select value={type} onValueChange={setType}>
              <SelectTrigger data-testid="select-cash-account-type" className={inputCls}><SelectValue /></SelectTrigger>
              <SelectContent className="bg-slate-900 border-slate-700 text-slate-100">
                <SelectItem value="bank">Bank account</SelectItem><SelectItem value="cash">Cash fund</SelectItem>
              </SelectContent>
            </Select>
          </Fld>
        </div>
        <DialogFooter><Button data-testid="button-save-cash-account" onClick={save} disabled={!name.trim()} className="bg-blue-600 hover:bg-blue-500">Save account</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
